/* global globalThis */

import React, { createContext, useContext } from 'react';
const Context = createContext(null);
export function developmentPreviewAllowed(location = globalThis.location) {
  return process.env.NODE_ENV === 'development'
    && process.env.REACT_APP_QUOTE_COMPOSITION_PREVIEW === 'b41-local'
    && (location?.protocol === 'file:' || ['127.0.0.1', 'localhost', '[::1]'].includes(location?.hostname));
}
// No application entry provides this context. Configuration alone never enables v2.
export function QuoteCompositionPreviewProvider({ connector, legacy = false, children }) {
  if (!developmentPreviewAllowed()) return children;
  return <Context.Provider value={{ connector, legacy, kind: 'icc-local-composition' }}>{children}</Context.Provider>;
}
export const useQuoteCompositionPreview = () => {
  const value = useContext(Context);
  return developmentPreviewAllowed() && value?.kind === 'icc-local-composition' ? value : null;
};
